/**
 * PhoneDisabledIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const PhoneDisabledIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M8.48 12.69a11 11 0 0 1-1.28-2.54A3.5 3.5 0 0 0 9 9.29l-1-6a3.2 3.2 0 0 0-.83-.24A3 3 0 0 0 6.6 3 3.6 3.6 0 0 0 3 6.6a14.35 14.35 0 0 0 2.9 8.67zm12.71-8.47a1 1 0 0 0-1.41 0L4.22 19.78a1 1 0 1 0 1.42 1.41l3.09-3.09A14.35 14.35 0 0 0 17.4 21a3.6 3.6 0 0 0 3.55-4.19 3.3 3.3 0 0 0-.25-.81l-6-1a3.5 3.5 0 0 0-.85 1.78 10.7 10.7 0 0 1-2.55-1.28l9.88-9.88a1 1 0 0 0 .01-1.4" />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const PhoneDisabledIcon = makeIcon('PhoneDisabledIcon', PhoneDisabledIconSvg)
